import { getPluginConfig } from "@src/api/plugin-configs/get-plugin-config";
import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { getShortOrgId } from "@src/store/slices/organization";

const { getPluginConfigState } = experienceBuilderSlice.selectors;
const { setPluginConfigState } = experienceBuilderSlice.actions;

export const updatePluginConfig = createAsyncThunk<void, void>(
  "experienceBuilder/updatePluginConfig",
  async (_, { dispatch, getState }) => {
    const pluginConfig = getPluginConfigState(getState());
    if (pluginConfig) {
      return;
    }

    const shortOrgId = getShortOrgId(getState());
    try {
      const meta = await getPluginConfig(shortOrgId);
      dispatch(
        setPluginConfigState({
          status: "loaded",
          version: meta?.embeddedPreviewVersion,
        })
      );
    } catch {
      dispatch(setPluginConfigState({ status: "error", version: undefined }));
    }
  }
);
